export enum FooterActions {
  APPROVE = 'Approve',
  REJECT = 'Reject',
  COMMENTS_CHANGE = 'COMMENTS_CHANGE',
  SAVE_AS_DRAFT = 'SAVE_AS_DRAFT',
  REVIEW_AND_CONFIRM = 'REVIEW_AND_CONFIRM',
  DELETE_REQUEST = 'DELETE_REQUEST',
  CANCEL = 'CANCEL',
  BACK_TO_REQUESTS = 'BACK_TO_REQUESTS',
  NEXT = 'NEXT',
  CONFIRM_REQUEST = 'CONFIRM_REQUEST',
  REASSIGN = 'REASSIGN',
}
